import React, { useState } from "react";
import Modal from "common/modal";
import InputField from "common/customInputField";
import pencil from "svg/pencil.svg";
import { api } from "store/slices/api";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { calcuateLineItemTotal } from "../../utils";

const LaborCodesEditModal = ({ laborCodeId, description, quantity, price, isTaxChecked }) => {
  const { quoteId, floorId } = useParams();
  const { data: quote = {} } = api.useGetPriceQuoteQuery(quoteId);
  const [show, setShow] = useState(false);
  const [editedFields, setEditedFields] = useState({ description, quantity, price });
  const [updateLaborCode] = api.useUpdateFloorLaborCodeMutation();

  const handleSave = () => {
    const { price, quantity, description } = editedFields;
    const totals = calcuateLineItemTotal({ price, quantity, taxRate: isTaxChecked ? quote.taxRate : 0 });
    const promiseParams = { success: "Changes saved", pending: "Saving changes", error: "Something went wrong" };
    toast.promise(updateLaborCode({ ...totals, laborCodeId, floorId, description }).unwrap(), promiseParams);
    setShow(false);
  };

  return (
    <td className="table-root-floor__body__tr__td table-root-floor__body__tr__td__text actions-align">
      <img src={pencil} className="actions-align" alt={"pencil-icon"} onClick={() => setShow(true)} />
      {show && (
        <Modal
          title="Edit Labor Data"
          saveButtonText="Save"
          closeButtonText="Cancel"
          handleSave={handleSave}
          handleCancel={() => setShow(false)}
          rootClass="transparent-backdrop"
          isSaveBtnDisabled={["", 0].includes(editedFields.quantity) || editedFields.price === ""}
          bodyClass="scroll-bar"
          size="lg"
        >
          <form className="search-form-container__fields__form">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Description"
                  id="description"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editedFields.description}
                  onChange={(e) => setEditedFields({ ...editedFields, description: e.target.value })}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="number"
                  label="Quantity"
                  id="quantity"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editedFields.quantity}
                  onChange={(e) =>
                    setEditedFields({
                      ...editedFields,
                      quantity: e.target.value === "" ? "" : Math.round(e.target.value * 100) / 100,
                    })
                  }
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="number"
                  label="Unit Price"
                  id="price"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editedFields.price}
                  onChange={(e) =>
                    setEditedFields({
                      ...editedFields,
                      price: e.target.value === "" ? "" : Math.round(Math.max(e.target.value, 0) * 100) / 100,
                    })
                  }
                />
              </div>
            </div>
          </form>
        </Modal>
      )}
    </td>
  );
};

export default LaborCodesEditModal;
